import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ManejoErroresService } from './manejo-errores/manejo-errores.service';
import { catchError, map, Observable } from 'rxjs';
import { ResponseGenericInterface } from '../interface/response-generic.interface';
import { GruposLinks, responseDataCurso } from '../interface/data-core';

@Injectable({
    providedIn: 'root'
})
export class CargarDataService {

    private URL_DATA_PORTAL = `${environment.config_url_json_portal}`; // URL to web api
    // private URL_DATA_PORTAL = `http://127.0.0.1:8000/api/Portal/curso`; // URL to web api
    private basePathData = 'assets/redi/data';

    constructor(
        private http: HttpClient,
        private manejoErrores: ManejoErroresService,
    ) {


    }

    getDataPortal(idPortal: number): Observable<ResponseGenericInterface<responseDataCurso>> {
        return this.http.post<ResponseGenericInterface<responseDataCurso>>(`${this.URL_DATA_PORTAL}`, { id: idPortal })
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.manejoErrores.handleErrors(err)
                })
            );
    }

    /**
  * 🔹 Obtiene JSON local desde assets/redi/data/{id}.json
  *     y lo adapta al mismo formato que la API
  */

    getDataById(idPortal: number): Observable<ResponseGenericInterface<responseDataCurso>> {
        const filePath = `${this.basePathData}/curso/${idPortal}.json`;
        return this.http.get<ResponseGenericInterface<responseDataCurso>>(filePath)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.manejoErrores.handleErrors(err)
                })
            );
    }

    getDataCatalogo(): Observable<ResponseGenericInterface<GruposLinks[]>> {
        const portal: string = environment.portal;
        const filePath = `${this.basePathData}/catalogos/${portal}.json`;
        return this.http.get<ResponseGenericInterface<GruposLinks[]>>(filePath)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.manejoErrores.handleErrors(err)
                })
            );
    }

       getDataLibros(archivo :string): Observable<ResponseGenericInterface<GruposLinks[]>> {
        const filePath = `${this.basePathData}/libros/${archivo}.json`;
        return this.http.get<ResponseGenericInterface<GruposLinks[]>>(filePath)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.manejoErrores.handleErrors(err)
                })
            );
    }

}
